import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { LocalStorageService } from 'src/app/services/local-storage.service';

import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams, IAfterGuiAttachedParams } from 'ag-grid-community';
import { ImpactService } from 'src/app/services/impact.service';
import { ProjectService } from 'src/app/services/project.service';
import { SharedServiceService } from 'src/app/services/shared-service.service';
import { UserInfoService } from 'src/app/services/user-info.service';
import { serverMessage } from 'src/app/popUpMessages/serverMessage';
import { AlertDialogComponent } from 'src/app/alert-dialog/alert-dialog.component';
import { NestedTreeControl } from '@angular/cdk/tree';
import { MatTreeNestedDataSource } from '@angular/material/tree';
import { messages } from 'src/app/popUpMessages/messages';

interface Node {
  name: string;
  id?: number;
  selected?: boolean;
  indeterminate?: boolean;
  children?: Node[];
  type?: string;
}
@Component({
  selector: 'app-configuration-Products',
  templateUrl: './configuration-Products.component.html',
  styleUrls: ['./configuration-Products.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class ConfigurationProductsComponent implements ICellRendererAngularComp {
  [x: string]: any;
  projectId: any;
  businessAreaId: any;
  businessLineId: any;
  showGrid: boolean = false;
  public allUserList: any;
  public userInOrg: any;
  projectSubmitterId: any;
  mDataImpProductTtl: any;
  showTree: boolean;
  public mProduct = [];
  hideButton: boolean;
  public saveBtnDisplay: boolean = true;
  public treeControl = new NestedTreeControl<Node>(node => node.children);
  public dataSource = new MatTreeNestedDataSource<Node>();
  //public data: any;
  public hasUnsavedChanges: boolean = false;
  public selectedNode: any;
  public flatdata: Node[] = [];
  public isEditable: boolean = true;

  public selectedDataProduct: any;
  public modifiedTreeData: any = [];
  public dbSelectedNodeIds = [];
  ideaSubmitterId: any;
  public showopw = false;
  recAllData: any;
  recImactedProd: any;
  public ImProdIdSelData = [];
  errorMessage: any;
  updatedProductData: any;
  treeDataSend: any[];
  configurationFromLocal: any;
  configurationData: any;
  configurationID: any;

  constructor(
    public dialogRef: MatDialogRef<ConfigurationProductsComponent>,
    private router: Router,
    public dialog: MatDialog,
    private localStorageService: LocalStorageService,
    private configurationService: ConfigurationService,
    private impactService: ImpactService,
    private projectService: ProjectService,
    private sharedService: SharedServiceService,
    private userService: UserInfoService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private configuration: ConfigurationService,

  ) { }
  public SelectedProductData = this.data.SelectedProductData || [];
  public ID = this.data.configurationData;

  refresh(params: ICellRendererParams): boolean {
    throw new Error('Method not implemented.');
  }
  agInit(params: ICellRendererParams): void {
    throw new Error('Method not implemented.');
  }
  afterGuiAttached?(params?: IAfterGuiAttachedParams): void {
    throw new Error('Method not implemented.');
  }

  ngOnInit(): void {
    this.projectId = this.localStorageService.get("projectId");
    // debugger;
    // console.log(this.SelectedProductData);
    //  console.log(this.data.productId)
    if (this.projectId != null) {
      this.projectService.getTCData(this.projectId).subscribe((data: any) => {
        if (data.StatusCode == 200) {
          this.businessAreaId = data.Data.BusinessAreaId;
          this.businessLineId = data.Data.BusinessLineId;
          this.sharedService.loggedInUser.subscribe((user: any) => {
            if (user) {
              this.showGrid = true;
              this.userService.getUserList(this.businessAreaId, this.businessLineId).subscribe((d) => {
                this.allUserList = d;
                this.userInOrg = this.allUserList.find(u => u.Email == user.Email);
                if (this.userInOrg != undefined) {
                  // console.log("user", this.userInOrg, data.Data);
                  this.projectSubmitterId = this.userInOrg.UserId;
                }
              })
            }
          })

          this.masterDataProduct();
        }
      });

    } else {
      this.businessAreaId = this.businessLineId = 0;
    }

  }
  masterDataProduct() {
    this.impactService.getMasterDataProduct(this.businessAreaId, this.businessLineId).subscribe((data: any) => {
      let errorMsgeFromBack = data.Data.Message;
      if (data.StatusCode == 200) {

        this.mDataImpProductTtl = data;
        this.mDataImpProductTtl = this.mDataImpProductTtl.Data;

        for (let i of this.mDataImpProductTtl) {
          this.mProduct.push({ productId: i.ProductId, productTitle: i.ProductTitle })
        }
        this.loadAllData();
        //this.loadTree();
      }
      else {
        //Show errorCode and errorMessage in the UI
        let errorContainer = [
          { [serverMessage.serverErrorMessage]: serverMessage.serverErrorHeader },
          { [serverMessage.message + errorMsgeFromBack]: serverMessage.serverErrorHeader }
        ]
        this.openAlertDialog(errorContainer)
      }
    },
      (error) => {
        this.hideButton = true;
        this.openAlertDialog([{ [serverMessage.serverAPIerror]: serverMessage.serverErrorHeader }])
      })
  }
  openAlertDialog(error) {
    this.dialog.open(AlertDialogComponent, { data: error })
  }


  loadAllData() {
    // debugger;   
    // this.configurationID = this.localStorageService.get("ConfigId");
    // this.configurationData = this.localStorageService.get("configuration");
    this.showGrid = false;
    let selectedProduct = [];
    // console.log(this.SelectedProductData)
    for (let i of this.SelectedProductData) {
      if(i.IsActive){
        selectedProduct.push({ id: i.ProductId });
        if(i.ImpactedProductId !== 0){
          this.ImProdIdSelData.push({ id: i.ProductId, ImpactedProductId: i.ImpactedProductId });
        }
      }
    }
    // console.log(this.ImProdIdSelData); 
    this.selectedDataProduct = selectedProduct;

    this.loadTree();
    // this.configuration.getImpactedData( this.projectId,this.ID ).subscribe((data: any) => {
    //   let errorMsgeFromBack = data.Data.Message;
    //   if (data.StatusCode == 200) {
    //     this.recAllData = data;
    //     this.recAllData = this.recAllData.Data;
    //     console.log(this.recAllData);
    //     this.recImactedProd = this.recAllData.Product;
    //     console.log(this.recImactedProd)

    //     let selectedProduct = [];
    //     for (let i of this.recImactedProd) {
    //       selectedProduct.push({ id: i.ProductId });
    //       this.ImProdIdSelData.push({ id: i.ProductId, ImpactedProductId: i.ImpactedProductId });
    //     }
    //     for (let i of this.SelectedProductData) {
    //        selectedProduct.push({ id: i.ProductId });
    //        this.ImProdIdSelData.push({ id: i.ProductId, ImpactedProductId: i.ImpactedProductId });
    //      }

    //     this.selectedDataProduct = selectedProduct;
    //     // Local storage:- setting isPLCselected =true/false;
    //     if (this.selectedDataProduct.length != 0) {
    //       this.localStorageService.set('isPLCseclected', true);
    //     } else {
    //       this.localStorageService.set('isPLCseclected', false);
    //     }
    //     this.loadTree();
    //     //   this.getCategorizationFormData(this.recCategorizationData);
    //   }
    //   else {
    //     //Show errorCode and errorMessage in the UI
    //     let errorContainer = [
    //       { [serverMessage.serverErrorMessage]: serverMessage.serverErrorHeader },
    //       { [serverMessage.message + errorMsgeFromBack]: serverMessage.serverErrorHeader }
    //     ]
    //     this.openAlertDialog(errorContainer);
    //   }
    // },
    //   (error) => {
    //     this.hideButton = true;
    //     //Show errorCode and errorMessage in the UI
    //     this.openAlertDialog([{ [serverMessage.serverAPIerror]: serverMessage.serverErrorHeader }]);
    //   })
  }
  loadTree() {
    this.showTree = true;
    this.showGrid = true;
    this.dataSource.data = this.mDataImpProductTtl;
    Object.keys(this.dataSource.data).forEach(x => {
      this.setParent(this.dataSource.data[Number(x)], null);
    });
    this.getFlatData(this.dataSource.data)
    this.getSelectedNode(this.flatdata)
    this.saveBtnDisplay = this.isEditable;
    //  this.loadGrid();
  }
  checkForError() {
    if (this.errorMessage.length != 0) {
      this.hideButton = false;
      this.openAlertDialog([{ [serverMessage.serverErrorMessage]: serverMessage.serverErrorHeader }]);
    } else {
      this.saveBtnDisplay = this.isEditable;
      // console.log(this.saveBtnDisplay);
      //this.loadGrid();
    }
  }
  /* To fetch the selected nodes from database and to autoselect and autoexpand them*/
  getSelectedNode(data: any) {
    this.selectedNode = this.selectedDataProduct;
    this.selectedNode.forEach((node: any) => {
      this.expand(data, node.id);
      data.forEach((d: any) => {
        if (d.id == node.id) {
          d.selected = true;
          this.dbSelectedNodeIds.push(node.id);
          this.todoItemSelectionToggle(true, d);
        }
      })
    })
  }
  hasChild = (_: number, node: Node) =>
    !!node.children && node.children.length > 0;

  // To set the parent of a node and make tree like structure
  setParent(data: any, parent: any) {
    data.parent = parent;
    if (data.children) {
      data.children.forEach((x: any) => {
        this.setParent(x, data);
      });
    }
  }
  /* To populate flatdata array with all the node present in the tree data 
    so that the flatdata can be passed to the getSelectedNode for easy searching of required node 
    for expand and toggle purposes*/
  getFlatData(dataSource: any) {
    dataSource.forEach((node: any) => {
      if (!node.children) {
        this.flatdata.push(node);
      }
      else if (node.children) {
        this.flatdata.push(node);
        this.getFlatData(node.children);
      }
    })
  }

  /* To auto expand the selected nodes coming from database */
  expand(data: any, uniqueId: number): any {
    data.forEach((node: any) => {
      if (node.id === uniqueId) {
        this.treeControl.expand(node);
        if (node.parent) {
          this.expand(this.dataSource.data, node.parent.id);
        }
      }
      else if (node.children?.find((c: any) => c.children)) {
        this.expand(node.children, uniqueId);
      }
    })
  }
  // toggle node selection
  todoItemSelectionToggle(checked: any, node: any, event?: any) {
    if (event != undefined) { //if the product node is selected/unselected from UI
      this.hasUnsavedChanges = true;
    }
    this.manageModifiedTreeData(checked, node);
    node.selected = checked;

    if (node.children) {
      node.children.forEach((x: any) => {
        if (x.type !== "version") {
          this.todoItemSelectionToggle(checked, x);
        }
      });
      // if (!node.selected && node.children) {
      //   if (node.children.every((child: any) => child.type == "version")) {
      //     node.children.forEach((x: any) => {
      //       x.selected = false;
      //       this.manageModifiedTreeData(false, x);
      //     });
      //   }
      // }
    }
    if (node.type == "product") {
      this.checkAllParents(node);
    } else {
      if (checked && event != undefined && !node.parent.selected) {
        this.manageModifiedTreeData(true, node.parent);
      }
      this.checkImmediateParent(node);
    }
  }

  /* To make the immediate parent of version node fully checked 
   instead of indeterminate even if all the version aren't selected*/
  checkImmediateParent(node: any) {
    node.parent.selected = true;
    node.parent.indeterminate = false;
    this.checkAllParents(node.parent);
  }
  // To check all parent node if a particular node is selected
  checkAllParents(node: any) {
    if (node.parent) {
      const descendants = this.treeControl.getDescendants(node.parent).filter((node) => node.type == "product");
      node.parent.selected = descendants.every(child => child.selected);
      node.parent.indeterminate = descendants.some(child => child.selected);
      this.checkAllParents(node.parent);
    }
  }

  manageModifiedTreeData(checked, node) {
    if (!node.selected && checked && (!node.children?.some(child => child.type == "product"))) {
      node.IsActive = true;
      node.CreatedBy = this.projectSubmitterId;
      node.ModifiedBy = null;
      this.getModifiedTreeData(node);
    }
    if (node.selected && checked && node.children.length > 0 && node.children.every(child => child.type == "version")) {
      if (!this.dbSelectedNodeIds.includes(node.id)) {
        this.getModifiedTreeData(node);
      }
    }
    // if the selected node is unchecked 
    if (!checked) {
      node.ModifiedBy = this.projectSubmitterId;
      node.IsActive = false;
      if (!node.children || !node.children.some(child => child.type == "product" && this.dbSelectedNodeIds.includes(child.Id))) {
        this.getModifiedTreeData(node);
      }
      if (!this.dbSelectedNodeIds.includes(node.id)) {
        this.modifiedTreeData = this.modifiedTreeData.filter(modifiedNode => {
          return modifiedNode.id != node.id;
        })
      }
    }
  }

  // this will give all the modified tree data;
  getModifiedTreeData(node) {
    let isPushed = false;
    if (this.modifiedTreeData.length == 0) {
      this.modifiedTreeData.push(node);
      isPushed = true;
    }
    else {
      this.modifiedTreeData.forEach(data => {
        if (node.id == data.id) {
          isPushed = true;
        }
      })
    }
    if (!isPushed) {
      this.modifiedTreeData.push(node);
    }
  }
  onSubmit() {
    let finaltreeData = [];
    this.treeDataSend = [];
    // console.log(this.modifiedTreeData);
    finaltreeData = this.modifiedTreeData.map(data => {
      return {
        ProductId: data.id,
        ConfigId: this.ID,
        IsActive: data.IsActive,
        CreatedBy: this.projectSubmitterId,
        CreatedOn: new Date().toISOString(),
        ModifiedBy: null,
        ModifiedOn: null
      }
    })
    // console.log(finaltreeData);
    // Binding product tree data;
    for (let j of finaltreeData) {
      let impactprodId = 0;
      for (let i of this.ImProdIdSelData) {
        if (i.id == j.ProductId) {
          impactprodId = i.ImpactedProductId;
          break;
        }
      }
      this.treeDataSend.push({
        ImpactedProductId: impactprodId,
        ProjectId: this.projectId,
        ConfigId: this.ID,
        ProductId: j.ProductId,
        IsActive: j.IsActive,
        CreatedBy: impactprodId === 0 ? this.projectSubmitterId : j.CreatedBy,
        CreatedOn: impactprodId === 0 ? new Date().toISOString() : j.CreatedOn,
        ModifiedBy: impactprodId === 0 ? null : this.projectSubmitterId,
        ModifiedOn: impactprodId === 0 ? null : new Date().toISOString(),
      })
    }
    // console.log(this.treeDataSend);
    this.updatedProductData = {
      UpdatedProductArray: this.getFinalMergedArray(),
    }
    this.dialogRef.close(this.updatedProductData);
  }

  getFinalMergedArray() {

    // If SelectedProductData is empty, null, or undefined, return all treeDataSend
    if (!this.SelectedProductData || this.SelectedProductData.length === 0) {
      return [...this.treeDataSend];
    }

    const finalArray: any[] = [];
    // Clone SelectedProductData to avoid mutating original
    const finalMergedArray = this.SelectedProductData.map(selected => {
      // Find matching treeDataSend object by ProductId
      const match = this.treeDataSend.find(tree =>
        tree.ProductId === selected.ProductId && tree.ImpactedProductId === selected.ImpactedProductId
      );
      if (match) {
        // Merge properties from treeDataSend into selected object
        return {
          ...selected,
          ImpactedProductId: match.ImpactedProductId,
          ProductId: match.ProductId,
          IsActive: match.IsActive,
          CreatedBy: match.CreatedBy,
          CreatedOn: match.CreatedOn,
          ModifiedBy: match.ModifiedBy,
          ModifiedOn: match.ModifiedOn,
          ProjectId: match.ProjectId,
          ConfigId: match.ConfigId
        };
      }
      // If no match, return the original selected object
      return selected;
    });

    // Add any objects from treeDataSend that are not in SelectedProductData
    this.treeDataSend.forEach(treeObj => {
      const exists = this.SelectedProductData.some(selected =>
        selected.ProductId === treeObj.ProductId && selected.ImpactedProductId === treeObj.ImpactedProductId
      );
      if (!exists) {
        finalArray.push(treeObj);
      }
    });

    finalMergedArray.forEach(obj => {
      if (obj.ImpactedProductId === 0 && obj.IsActive === true) {
        finalArray.push(obj);
      }
    });

    finalMergedArray.forEach(obj => {
      if (obj.ImpactedProductId !== 0) {
        finalArray.push(obj);
      }
    });

    // console.log(finalArray);
    return finalArray;
  }
}
